import React from 'react';
import { withPrefix } from 'gatsby';

// Hook to get cc parameter from URL
export const useCcParam = (): string | null => {
    const [ccParam, setCcParam] = React.useState<string | null>(null);

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search);
            setCcParam(urlParams.get('cc'));
        }
    }, []);

    return ccParam;
}

// Function to append cc parameter to a URL
export const buildUrl = (url: string, ccParam?: string | null): string => {
    if (url.startsWith('#') || !ccParam || url.startsWith('http')) return url;
    
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
        return url;
    }
    
    const urlObj = new URL(withPrefix(url), window.location.origin);
    if (ccParam) {
        urlObj.searchParams.set('cc', ccParam);
    }
    return urlObj.href;
}
